import { CustomerDto, FileRecordDto, ModelEventDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';
import { PageEvent } from '@angular/material/paginator';

export interface BulkCustomerImportRequest {
  firstName: string;
  lastName: string;
  externalId?: string;
  address1?: string;
  address2?: string;
  town?: string;
  state?: string;
  postcode?: string;
  country?: string;
  dateOfBirth?: string;
  allowsMedia?: string;

  family_Email?: string;
  family_Email1?: string;
  family_Email2?: string;
  family_Email3?: string;
  family_Email4?: string;
  family_Email5?: string;
  family_Email6?: string;
  family_Email7?: string;
  family_Email8?: string;
  family_Email9?: string;
  family_Email10?: string;
}

export class CustomerActionFactory extends CareAppListActionFactory<CustomerDto> {
  get RESPONSE_SUCCESS_ADD_CUSTOMER_FILE() {
    return `[${this.type}][Response][Success] Add Customer File`;
  }
  get RESPONSE_FAIL_ADD_CUSTOMER_FILE() {
    return `[${this.type}][Response][Fail] Add Customer File`;
  }

  get REQUEST_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Request] Bulk Add Customers`;
  }
  get PROGRESS_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Progress] Bulk Add Customers`;
  }
  get RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Response][Success] Bulk Add Customers`;
  }
  get RESPONSE_FAIL_BULK_ADD_CUSTOMERS() {
    return `[${this.type}][Response][Fail] Bulk Add Customers`;
  }
  get REQUEST_ACCESS() {
    return `[${this.type}][Request] Access`;
  }

  get RESPONSE_SUCCESS_ACCESS() {
    return `[${this.type}][Response][Success] Access`;
  }

  get RESPONSE_FAIL_ACCESS() {
    return `[${this.type}][Response][Fail] Access`;
  }

  RequestAllPaginated = createAction(
    `[${this.type}][Request] All Paginated (by Id)`,
    props<{
      clear?: boolean;
      paginatorId?: string;
      enabledOnly?: boolean;
    }>()
  );

  ResponseSuccessAllPaginated = createAction(
    `[${this.type}][Response][Success] All Paginated (By Id)`,
    props<{
      filter?: { externalId?: string; name?: string; limit?: number };
      paginator?: string;
      items: CustomerDto[];
      page?: PageEvent;
    }>()
  );

  RequestAssignCustomerFile = createAction(
    `[${this.type}][Request] Assign Customer File`,
    props<{
      customerId: string;
      fileId: string;
      roles?: string[];
    }>()
  );

  ResponseSuccessAssignCustomerFile = createAction(
    `[${this.type}][Response][Success] Assign Customer File`,
    props<{
      customerId: string;
      file: FileRecordDto;
    }>()
  );

  ResponseFailAssignCustomerFile = createAction(
    `[${this.type}][Response][Fail] Assign Customer File`,
    props<{
      customerId: string;
      fileId: string;
      error: any;
    }>()
  );

  RequestAddLink = createAction(
    `[${this.type}][Request] Add Customer Link`,
    props<{
      customerId: string;
      url: string;
      description: string;
      roles?: string[];
    }>()
  );

  ResponseSuccessAddLink = createAction(
    `[${this.type}][Response][Success] Add Customer Link`,
    props<{
      customer: CustomerDto;
    }>()
  );

  ResponseFailAddLink = createAction(
    `[${this.type}][Response][Fail] Add Customer Link`,
    props<{
      customerId: string;
      error: any;
    }>()
  );

  RequestUpdateLink = createAction(
    `[${this.type}][Request] Update Customer Link`,
    props<{
      customerId: string;
      urlId: string;
      url: string;
      description: string;
      roles?: string[];
    }>()
  );

  ResponseSuccessUpdateLink = createAction(
    `[${this.type}][Response][Success] Update Customer Link`,
    props<{
      customer: CustomerDto;
    }>()
  );

  ResponseFailUpdateLink = createAction(
    `[${this.type}][Response][Fail] Update Customer Link`,
    props<{
      customerId: string;
      urlId: string;
      error: any;
    }>()
  );

  RequestRemoveLink = createAction(
    `[${this.type}][Request] Remove Customer Link`,
    props<{
      customerId: string;
      urlId: string;
    }>()
  );

  ResponseSuccessRemoveLink = createAction(
    `[${this.type}][Response][Success] Remove Customer Link`,
    props<{
      customer: CustomerDto;
    }>()
  );

  ResponseFailRemoveLink = createAction(
    `[${this.type}][Response][Fail] Remove Customer Link`,
    props<{
      customerId: string;
      urlId: string;
      error: any;
    }>()
  );

  RequestLogLinkView = createAction(
    `[${this.type}][Request] log link view`,
    props<{
      customerId: string;
      urlId: string;
    }>()
  );
  SuccessLogLinkView = createAction(
    `[${this.type}][Response][Success] log link view`,
    props<{
      customerId: string;
      urlId: string;
    }>()
  );
  FailLogLinkView = createAction(
    `[${this.type}][Response][Fail] log link view`,
    props<{
      customerId: string;
      urlId: string;
      error: any;
    }>()
  );

  RequestLinkHistory = createAction(
    `[${this.type}][Request] link history`,
    props<{
      customerId: string;
      urlId: string;
    }>()
  );
  SuccessLinkHistory = createAction(
    `[${this.type}][Response][Success] link history`,
    props<{
      customerId: string;
      urlId: string;
      history: ModelEventDto[];
    }>()
  );
  FailLinkHistory = createAction(
    `[${this.type}][Response][Fail] link history`,
    props<{
      customerId: string;
      urlId: string;
      error: any;
    }>()
  );

  ResponseSuccessAddCustomerFile(payload: any) {
    return {
      type: this.RESPONSE_SUCCESS_ADD_CUSTOMER_FILE,
      payload,
    };
  }

  ResponseFailAddCustomerFile(payload: any) {
    return {
      type: this.RESPONSE_FAIL_ADD_CUSTOMER_FILE,
      payload,
    };
  }

  RequestBulkAddCustomers(payload: BulkCustomerImportRequest[]) {
    return {
      type: this.REQUEST_BULK_ADD_CUSTOMERS,
      payload,
    };
  }

  ProgressBulkAddCustomers(payload: number) {
    return {
      type: this.PROGRESS_BULK_ADD_CUSTOMERS,
      payload,
    };
  }

  ResponseSuccessBulkAddCustomers(payload: CustomerDto[]) {
    return {
      type: this.RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS,
      payload,
    };
  }

  ResponseFailBulkAddCustomers(payload: any) {
    return {
      type: this.RESPONSE_FAIL_BULK_ADD_CUSTOMERS,
      payload,
    };
  }

  RequestAccess(payload: { id: string }) {
    return {
      type: this.REQUEST_ACCESS,
      payload,
    };
  }

  ResponseSuccessAccess(payload: { id: string }) {
    return {
      type: this.RESPONSE_SUCCESS_ACCESS,
      payload,
    };
  }

  ResponseFailAccess(payload: { id: string; error?: any }) {
    return {
      type: this.RESPONSE_FAIL_ACCESS,
      payload,
    };
  }

  constructor() {
    super(`Customers`);
  }
}

export const Customers = new CustomerActionFactory();
